import React, { useState, useEffect, useRef, useContext } from "react";

import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "../../services/toast";
import { head } from "lodash";

import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import MoodIcon from "@mui/icons-material/Mood";

import { makeStyles } from 'tss-react/mui';
import { green } from "@mui/material/colors";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined";
import ButtonBase from "@mui/material/ButtonBase";
import Chip from "@mui/material/Chip";
import CloudIcon from "@mui/icons-material/Cloud";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ChatBubbleIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";

import { i18n } from "../../translate/i18n";
import moment from "moment";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Checkbox,
  ListItemText,
  Input,
  Typography
} from "@mui/material";
import { AuthContext } from "../../context/Auth/AuthContext";
import ConfirmationModal from "../ConfirmationModal";
import TemplatePreview from "../TemplatePreview";
import {
  aInstante,
  aHoraDePared,
  zonaLocal,
  etiquetaZona,
  nombreZona,
  zonasDisponibles
} from "../../helpers/timezone";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },

  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  sendMessageIcons: {
    color: "grey",
  },
  emojiBox: {
    position: "absolute",
    bottom: -163,
    width: 40,
    borderTop: `1px solid ${theme.palette.divider}`,
    zIndex: 100
  },

  tabs: {
    minHeight: 42,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.grey[100]
        : "rgba(255,255,255,0.04)",
    "& .MuiTab-root": {
      minHeight: 42,
      textTransform: "none",
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },

  bloqueVars: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
  },
  bloqueVarsTitulo: {
    display: "block",
    marginBottom: theme.spacing(0.5),
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },

  opciones: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: theme.spacing(2),
  },
  opcion: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(2.5, 2),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    height: "100%",
    transition: "border-color .15s, background-color .15s, transform .15s",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "light"
          ? "rgba(0,0,0,0.02)"
          : "rgba(255,255,255,0.04)",
      transform: "translateY(-2px)",
    },
  },
  opcionIcono: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
    borderRadius: "50%",
    fontSize: 30,
    marginBottom: theme.spacing(0.5),
  },
  opcionTitulo: {
    fontWeight: 700,
    fontSize: 16,
  },
  opcionTexto: {
    fontSize: 12.5,
    lineHeight: 1.45,
    color: theme.palette.text.secondary,
  },
  seccion: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(-0.5),
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  previewVacia: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    minHeight: 300,
    marginTop: theme.spacing(1),
    padding: theme.spacing(3),
    textAlign: "center",
    borderRadius: 14,
    border: `1px dashed ${theme.palette.divider}`,
    color: theme.palette.text.disabled,
    fontSize: 13,
  },
  previewIcono: {
    fontSize: 38,
    opacity: 0.5,
  },
  columnaPreview: {
    position: "sticky",
    top: 0,
  },
  canalElegido: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },

  aviso: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor:
      theme.palette.mode === "light"
        ? "rgba(0,0,0,0.02)"
        : "rgba(255,255,255,0.03)",
    color: theme.palette.text.secondary,
    "& code": {
      padding: "1px 4px",
      borderRadius: 3,
      backgroundColor:
        theme.palette.mode === "light"
          ? "rgba(0,0,0,0.06)"
          : "rgba(255,255,255,0.08)",
      fontSize: "0.9em",
    },
  },
}));

const filtrarListas = createFilterOptions({ limit: 20, trim: true });

const zonas = zonasDisponibles();

const CANAL = {
  whatsapp_cloud: { nombre: "WhatsApp Cloud", color: "#0084FF" },
  whatsapp: { nombre: "WhatsApp", color: "#25D366" },
};

const CampaignSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  message1: Yup.string().test(
    "has-variable",
    "Must include at least one of {nombre}, {numero}, {email}",
    function (value) {
      if (this.parent?.templateId) return true;

      return (
        !value ||
        value.includes("{nombre}") ||
        value.includes("{numero}") ||
        value.includes("{email}")
      );
    }
  ),

});

const CampaignModal = ({
  open,
  onClose,
  campaignId,
  initialValues,
  onSave,
  resetPagination,
}) => {
  const { classes } = useStyles();
  const isMounted = useRef(true);
  const { user } = useContext(AuthContext);
  const { companyId } = user;

  const initialState = {
    name: "",
    message1: "",
    message2: "",
    message3: "",
    message4: "",
    message5: "",
    confirmationMessage1: "",
    confirmationMessage2: "",
    confirmationMessage3: "",
    confirmationMessage4: "",
    confirmationMessage5: "",
    status: "INACTIVA",
    confirmation: false,
    scheduledAt: "",
    contactListId: "",
    templateId: "",
    companyId,
  };

  const [campaign, setCampaign] = useState(initialState);
  const [whatsapps, setWhatsapps] = useState([]);
  const [contactLists, setContactLists] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [todasConexiones, setTodasConexiones] = useState([]);
  const [varsPlantilla, setVarsPlantilla] = useState({});

  const [canalCampana, setCanalCampana] = useState("");

  const [zonaCampana, setZonaCampana] = useState(zonaLocal());

  const [conexionCloud, setConexionCloud] = useState("");
  const [messageTab, setMessageTab] = useState(0);
  const [attachment, setAttachment] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [campaignEditable, setCampaignEditable] = useState(true);

  const [whatsappSeleted, setWhatsappSeleted] = useState([]);

  const attachmentFile = useRef(null);

  const [showEmoji, setShowEmoji] = useState(false);

  const EmojiOptions = (props) => {
    const { showEmoji, setShowEmoji, handleAddEmoji } = props;
    const { classes } = useStyles();
    return (
      <>
        <IconButton
          aria-label="emojiPicker"
          component="span"
          onClick={(e) => setShowEmoji((prevState) => !prevState)}
          size="large">
          <MoodIcon className={classes.sendMessageIcons} />
        </IconButton>
        {showEmoji ? (
          <div className={classes.emojiBox}>
            <Picker
              data={data}
              perLine={16}
              previewPosition="none"
              skinTonePosition="none"
              onEmojiSelect={handleAddEmoji}
            />
          </div>
        ) : null}
      </>
    );
  };

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      if (initialValues) {
        setCampaign((prevState) => {
          return { ...prevState, ...initialValues };
        });
      }

      api
        .get(`/contact-lists/list`, { params: { companyId } })
        .then(({ data }) => setContactLists(data));

      api
        .get(`/whatsapp`, { params: { companyId, session: 0, iscampaings: 1 } })
        .then(({ data }) => setWhatsapps(data));

      api
        .get(`/whatsapp`, { params: { companyId, session: 0 } })
        .then(({ data }) => setTodasConexiones(Array.isArray(data) ? data : []))
        .catch(() => setTodasConexiones([]));

      api
        .get(`/template-message/list`, { params: { companyId } })
        .then(({ data }) =>
          setTemplates(
            (Array.isArray(data) ? data : []).filter(
              (t) =>
                String(t.status || "").toUpperCase() === "APPROVED" &&
                t.forCampaign === true
            )
          )
        )
        .catch(() => setTemplates([]));

      if (!campaignId) return;

      api.get(`/campaigns/${campaignId}`).then(({ data }) => {
        const zonaGuardada = data.scheduledTimezone || zonaLocal();
        setZonaCampana(zonaGuardada);

        setCampaign((prev) => {
          let prevCampaignData = Object.assign({}, prev);

          Object.entries(data).forEach(([key, value]) => {
            if (key === "scheduledAt" && value !== "" && value !== null) {
              prevCampaignData[key] = aHoraDePared(value, zonaGuardada);
            } else {
              prevCampaignData[key] = value === null ? "" : value;
            }
          });

          return prevCampaignData;
        });
      });
    }
  }, [campaignId, open, initialValues, companyId]);

  useEffect(() => {
    const now = moment();
    const scheduledAt = moment(campaign.scheduledAt);
    const moreThenAnHour =
      !Number.isNaN(scheduledAt.diff(now)) && scheduledAt.diff(now, "hour") > 1;
    const isEditable =
      campaign.status === "INACTIVA" ||
      (campaign.status === "PROGRAMADA" && moreThenAnHour);

    setCampaignEditable(isEditable);
  }, [campaign.status, campaign.scheduledAt]);

  useEffect(() => {
    if (!campaignId) return;
    if (campaign.templateId) {
      setCanalCampana("whatsapp_cloud");
    } else if (campaign.id) {
      setCanalCampana("whatsapp");
    }
  }, [campaignId, campaign.id, campaign.templateId]);

  useEffect(() => {
    if (!campaign.templateId || !templates.length) return;

    const plantilla = templates.find(
      (t) => String(t.id) === String(campaign.templateId)
    );
    if (!plantilla) return;

    const partes = String(campaign.message1 || "").split("|");
    const recuperados = {};

    [...(plantilla.variables || [])]
      .sort((a, b) => (a.position || 0) - (b.position || 0))
      .forEach((v, i) => {
        const source = String(v.source || "MANUAL").toUpperCase();
        if (source !== "MANUAL") return;
        if (partes[i] !== undefined) recuperados[v.position] = partes[i];
      });

    setVarsPlantilla(recuperados);
  }, [campaign.templateId, campaign.message1, templates]);

  const handleAddEmoji = (e, textareaName) => {
    if (typeof textareaName === 'string') {
      let emoji = e.native;
      addTextToTextarea(emoji, textareaName);
    }

  };

  const addTextToTextarea = (text, textareaName) => {

    let textareaElement = document.getElementById(textareaName).value;
    textareaElement = textareaElement + ' ' + text + ' ';
    
  };

  const renderAddTextButton = (textareaName) => (
    <div>
      <h4>Variables disponibles: </h4>

      <EmojiOptions
        handleAddEmoji={(emoji) => handleAddEmoji(emoji, textareaName)}
        showEmoji={showEmoji}
        setShowEmoji={setShowEmoji}

      />

      <Button
        onClick={() => addTextToTextarea(' {nombre} ', textareaName)}
        color="primary"
        size="small"
        variant="outlined"
        style={{ marginRight: '10px' }}
      >
        Nombre
      </Button>
      <Button
        onClick={() => addTextToTextarea(' {numero} ', textareaName)}
        color="primary"
        size="small"
        variant="outlined"
        style={{ marginRight: '10px' }}
      >
        Numero
      </Button>
      <Button
        onClick={() => addTextToTextarea(' {email} ', textareaName)}
        color="primary"
        size="small"
        variant="outlined"
      >
        Correo Electronico
      </Button>
    </div>

  );

  const handleClose = () => {
    onClose();
    setCampaign(initialState);
    setCanalCampana("");
    setVarsPlantilla({});
    setConexionCloud("");
  };

  const handleAttachmentFile = (e) => {
    const file = head(e.target.files);
    if (file) {
      setAttachment(file);
    }
  };

  const handleChange = (event) => {

    const {
      target: { value },
    } = event;

    const valueArray = typeof value === 'string' ? value.split(',') : value;
    if (valueArray.length <= 3) {
      setWhatsappSeleted(valueArray);
    } else {
      toastError('Solo puedes seleccionar hasta 3 conexiones.');
    }

  };

  const conexionesCloud = todasConexiones.filter(
    (w) => w.channel === "whatsapp_cloud"
  );

  const conexionEfectiva = (templateId) => {
    if (conexionCloud) return conexionCloud;

    const elegida = templates.find((t) => String(t.id) === String(templateId));
    return elegida?.whatsappId || "";
  };

  const plantillaElegida = (templateId) =>
    templates.find((t) => String(t.id) === String(templateId)) || null;

  const variablesDe = (plantilla) =>
    [...(plantilla?.variables || [])].sort(
      (a, b) => (a.position || 0) - (b.position || 0)
    );

  const valorDeVariable = (v) => {
    const source = String(v.source || "MANUAL").toUpperCase();
    if (source === "CONTACT_NAME") return "{nombre}";
    if (source === "CONTACT_NUMBER") return "{numero}";
    if (source === "CONTACT_EMAIL") return "{email}";
    return varsPlantilla[v.position] ?? "";
  };

  const necesitaValor = (v) =>
    !["CONTACT_NAME", "CONTACT_NUMBER", "CONTACT_EMAIL"].includes(
      String(v.source || "MANUAL").toUpperCase()
    );

  const etiquetaDeVariable = (v) => {
    if (String(v.source || "").toUpperCase() === "USER_NAME") {
      return v.label || "Nombre del remitente";
    }
    return v.label || `Variable ${v.position}`;
  };

  const construirValoresPlantilla = (plantilla) =>
    variablesDe(plantilla).map(valorDeVariable).join("|");

  const valoresParaPreview = (plantilla) => {
    const mapa = {};
    variablesDe(plantilla).forEach((v) => {
      const valor = valorDeVariable(v);
      if (valor) mapa[v.position] = valor;
    });
    return mapa;
  };

  const textoAgenda = (valor) => {
    if (!valor) return `La hora se lee en ${nombreZona(zonaCampana)}.`;

    const instante = aInstante(valor, zonaCampana);
    if (!instante) return `La hora se lee en ${nombreZona(zonaCampana)}.`;

    if (instante.getTime() < Date.now()) {
      return `Esa hora ya pasó en ${nombreZona(zonaCampana)}. La campaña no saldría.`;
    }

    const cuando = moment(instante);
    const propia = zonaLocal();

    const enTuHora =
      zonaCampana === propia
        ? ""
        : ` · ${cuando.format("HH:mm")} en tu hora (${nombreZona(propia)})`;

    return `Sale ${cuando.fromNow()}${enTuHora}`;
  };

  const handleSaveCampaign = async (values) => {
    try {
      const plantilla = templates.find(
        (t) => String(t.id) === String(values.templateId)
      );

      const dataValues = {
        ...campaign,
        whatsappIds: plantilla
          ? String(conexionEfectiva(values.templateId) || plantilla.whatsappId)
          : whatsappSeleted.join(",")
      };

      Object.entries(values).forEach(([key, value]) => {
        if (key === "scheduledAt" && value !== "" && value !== null) {
          dataValues[key] = aInstante(value, zonaCampana)?.toISOString() || null;
          dataValues.scheduledTimezone = zonaCampana || null;
        } else {
          dataValues[key] = value === "" ? null : value;
        }
      });

      if (plantilla) {
        dataValues.message1 = construirValoresPlantilla(plantilla);
        dataValues.message2 = null;
        dataValues.message3 = null;
        dataValues.message4 = null;
        dataValues.message5 = null;
      }

      if (campaignId) {
        await api.put(`/campaigns/${campaignId}`, dataValues);

        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/campaigns/${campaignId}/media-upload`, formData);
        }
        handleClose();
      } else {
        const { data } = await api.post("/campaigns", dataValues);

        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/campaigns/${data.id}/media-upload`, formData);
        }
        if (onSave) {
          onSave(data);
        }
        handleClose();
      }
      toast.success(i18n.t("campaigns.toasts.success"));
    } catch (err) {
      console.log(err);
      toastError(err);
    }
  };

  const deleteMedia = async () => {
    if (attachment) {
      setAttachment(null);
      attachmentFile.current.value = null;
    }

    if (campaign.mediaPath) {
      await api.delete(`/campaigns/${campaign.id}/media-upload`);
      setCampaign((prev) => ({ ...prev, mediaPath: null, mediaName: null }));
      toast.success(i18n.t("campaigns.toasts.deleted"));
    }
  };

  const renderMessageField = (identifier, errors, touched) => {
    return (

      <Field
        as={TextField}
        id={identifier}
        name={identifier}
        fullWidth
        rows={5}
        label={i18n.t(`campaigns.dialog.form.${identifier}`)}
        placeholder={i18n.t("campaigns.dialog.form.messagePlaceholder")}
        multiline={true}
        onClick={() => setShowEmoji(false)}
        variant="outlined"
        error={touched[identifier] && Boolean(errors[identifier])}
        helperText="Utilice variables como {nombre}, {numero}, {email} o defina variables personalizadas."
        disabled={!campaignEditable && campaign.status !== "CANCELADA"}
      />

    );
  };

  const renderConfirmationMessageField = (identifier) => {
    return (
      <Field
        as={TextField}
        id={identifier}
        name={identifier}
        fullWidth
        rows={5}
        label={i18n.t(`campaigns.dialog.form.${identifier}`)}
        placeholder={i18n.t("campaigns.dialog.form.messagePlaceholder")}
        multiline={true}
        variant="outlined"
        disabled={!campaignEditable && campaign.status !== "CANCELADA"}
      />
    );
  };

  const cancelCampaign = async () => {
    try {
      await api.post(`/campaigns/${campaign.id}/cancel`);
      toast.success(i18n.t("campaigns.toasts.cancel"));
      setCampaign((prev) => ({ ...prev, status: "CANCELADA" }));
      resetPagination();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const restartCampaign = async () => {
    try {
      await api.post(`/campaigns/${campaign.id}/restart`);
      toast.success(i18n.t("campaigns.toasts.restart"));
      setCampaign((prev) => ({ ...prev, status: "EM_ANDAMENTO" }));
      resetPagination();
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div className={classes.root}>
      <ConfirmationModal
        title={i18n.t("campaigns.confirmationModal.deleteTitle")}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={deleteMedia}
      >
        {i18n.t("campaigns.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
          {campaignEditable ? (
            <>
              {campaignId
                ? `${i18n.t("campaigns.dialog.update")}`
                : `${i18n.t("campaigns.dialog.new")}`}
            </>
          ) : (
            <>{`${i18n.t("campaigns.dialog.readonly")}`}</>
          )}
        </DialogTitle>
        <div style={{ display: "none" }}>
          <input
            type="file"
            ref={attachmentFile}
            onChange={(e) => handleAttachmentFile(e)}
          />
        </div>
        {!canalCampana ? (
          <>
            <DialogContent dividers>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ mb: 2 }}
              >
                ¿Por dónde quieres enviar esta campaña?
              </Typography>

              <div className={classes.opciones}>
                <ButtonBase
                  className={classes.opcion}
                  onClick={() => setCanalCampana("whatsapp_cloud")}
                  sx={{
                    "&:hover": { borderColor: CANAL.whatsapp_cloud.color },
                  }}
                >
                  <div
                    className={classes.opcionIcono}
                    style={{
                      backgroundColor: `${CANAL.whatsapp_cloud.color}1f`,
                      color: CANAL.whatsapp_cloud.color,
                    }}
                  >
                    <CloudIcon fontSize="inherit" />
                  </div>
                  <div className={classes.opcionTitulo}>WhatsApp Cloud</div>
                  <div className={classes.opcionTexto}>
                    Con una plantilla aprobada por Meta. Llega a contactos que
                    no te han escrito nunca. Cada mensaje se cobra.
                  </div>
                </ButtonBase>

                <ButtonBase
                  className={classes.opcion}
                  onClick={() => setCanalCampana("whatsapp")}
                  sx={{ "&:hover": { borderColor: CANAL.whatsapp.color } }}
                >
                  <div
                    className={classes.opcionIcono}
                    style={{
                      backgroundColor: `${CANAL.whatsapp.color}1f`,
                      color: CANAL.whatsapp.color,
                    }}
                  >
                    <WhatsAppIcon fontSize="inherit" />
                  </div>
                  <div className={classes.opcionTitulo}>WhatsApp</div>
                  <div className={classes.opcionTexto}>
                    Texto libre por una línea conectada. Solo llega a quien te
                    escribió en las últimas 24 h y arriesga el bloqueo del
                    número.
                  </div>
                </ButtonBase>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="secondary">
                {i18n.t("campaigns.dialog.buttons.close")}
              </Button>
            </DialogActions>
          </>
        ) : (
        <Formik
          initialValues={campaign}
          enableReinitialize={true}
          validationSchema={CampaignSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveCampaign(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, errors, touched, isSubmitting, setFieldValue }) => {
            const plantillaActual = plantillaElegida(values.templateId);
            const hayPreview = canalCampana === "whatsapp_cloud";

            return (
            <Form>
              <DialogContent dividers>
                <div className={classes.canalElegido}>
                  <Chip
                    size="small"
                    icon={
                      canalCampana === "whatsapp_cloud" ? (
                        <CloudIcon />
                      ) : (
                        <WhatsAppIcon />
                      )
                    }
                    label={CANAL[canalCampana]?.nombre || canalCampana}
                    sx={{
                      fontWeight: 700,
                      color: "#fff",
                      backgroundColor: CANAL[canalCampana]?.color || "#9e9e9e",
                      "& .MuiChip-icon": { color: "#fff" },
                    }}
                  />
                  {!campaignId && campaignEditable && (
                    <Button size="small" onClick={() => setCanalCampana("")}>
                      Cambiar
                    </Button>
                  )}
                </div>

                <Grid spacing={2} container>
                  <Grid size={{ xs: 12, md: hayPreview ? 7 : 12 }}>
                <Grid spacing={1.5} container>
                  <Grid size={12}>
                    <Field
                      as={TextField}
                      label={i18n.t("campaigns.dialog.form.name")}
                      name="name"
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                      variant="outlined"
                      size="small"
                      fullWidth
                      disabled={!campaignEditable}
                    />
                  </Grid>

                  <Grid size={12}>
                    <div className={classes.seccion}>Plantilla</div>
                  </Grid>

                  {canalCampana === "whatsapp_cloud" && (
                  <Grid size={12}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="template-selection-label">
                        {i18n.t("campaigns.dialog.form.template")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.template")}
                        labelId="template-selection-label"
                        id="templateId"
                        name="templateId"
                        disabled={!campaignEditable}
                      >
                        {templates.length === 0 && (
                          <MenuItem value="" disabled>
                            No hay plantillas disponibles
                          </MenuItem>
                        )}
                        {templates.map((t) => (
                          <MenuItem key={t.id} value={t.id}>
                            {t.name}
                          </MenuItem>
                        ))}
                      </Field>
                    </FormControl>

                    {templates.length === 0 && (
                      <Box className={classes.aviso}>
                        <Typography variant="caption" component="div">
                          No hay ninguna plantilla disponible. Para que aparezca
                          aquí tiene que estar <b>aprobada por Meta</b> y
                          marcada como <b>«Disponible para campañas masivas»</b>{" "}
                          en su ficha.
                        </Typography>
                      </Box>
                    )}
                  </Grid>
                  )}

                  {values.templateId &&
                    (() => {
                      const plantilla = templates.find(
                        (t) => String(t.id) === String(values.templateId)
                      );
                      if (!plantilla) return null;

                      const manuales =
                        variablesDe(plantilla).filter(necesitaValor);

                      return (
                        <Grid size={12}>
                          {manuales.length > 0 && (
                            <Box className={classes.bloqueVars}>
                              <Typography
                                variant="caption"
                                className={classes.bloqueVarsTitulo}
                              >
                                Esta plantilla espera {manuales.length} dato
                                {manuales.length === 1 ? "" : "s"}
                              </Typography>
                              <Grid spacing={1} container>
                                {manuales.map((v) => (
                                  <Grid
                                    key={v.position}
                                    size={{ xs: 12, sm: 6 }}
                                  >
                                    <TextField
                                      label={etiquetaDeVariable(v)}
                                      placeholder={v.exampleValue || ""}
                                      value={varsPlantilla[v.position] || ""}
                                      onChange={(e) =>
                                        setVarsPlantilla((prev) => ({
                                          ...prev,
                                          [v.position]: e.target.value
                                        }))
                                      }
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      disabled={!campaignEditable}
                                    />
                                  </Grid>
                                ))}
                              </Grid>
                            </Box>
                          )}

                        </Grid>
                      );
                    })()}
                  <Grid size={12}>
                    <div className={classes.seccion}>Destino</div>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <Autocomplete
                      options={contactLists || []}
                      getOptionLabel={(o) => o?.name || ""}
                      isOptionEqualToValue={(o, v) => o.id === v.id}
                      filterOptions={filtrarListas}
                      size="small"
                      value={
                        (contactLists || []).find(
                          (c) => String(c.id) === String(values.contactListId)
                        ) || null
                      }
                      onChange={(e, opcion) =>
                        setFieldValue("contactListId", opcion ? opcion.id : "")
                      }
                      disabled={!campaignEditable}
                      noOptionsText="Sin resultados"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={i18n.t("campaigns.dialog.form.contactList")}
                          variant="outlined"
                          error={
                            touched.contactListId &&
                            Boolean(errors.contactListId)
                          }
                        />
                      )}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    {canalCampana === "whatsapp_cloud" ? (
                      <Autocomplete
                        options={conexionesCloud}
                        getOptionLabel={(o) => o?.name || ""}
                        isOptionEqualToValue={(o, v) => o.id === v.id}
                        size="small"
                        value={
                          conexionesCloud.find(
                            (w) =>
                              String(w.id) ===
                              String(conexionEfectiva(values.templateId))
                          ) || null
                        }
                        onChange={(e, opcion) =>
                          setConexionCloud(opcion ? opcion.id : "")
                        }
                        disabled={!campaignEditable}
                        noOptionsText="No hay conexiones Cloud"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={i18n.t("campaigns.dialog.form.whatsapp")}
                            variant="outlined"
                          />
                        )}
                      />
                    ) : (
                      <FormControl variant="outlined" size="small" fullWidth>
                        <InputLabel id="whatsapp-selection-label">
                          {i18n.t("campaigns.dialog.form.whatsapp")}
                        </InputLabel>
                        <Select
                          multiple
                          id="whatsappId"
                          name="whatsappId"
                          labelId="whatsapp-selection-label"
                          label={i18n.t("campaigns.dialog.form.whatsapp")}
                          value={whatsappSeleted}
                          onChange={handleChange}
                          disabled={!campaignEditable}
                          renderValue={(selectedIds) =>
                            selectedIds
                              .map(
                                (id) =>
                                  whatsapps.find((w) => w.id === id)?.name || id
                              )
                              .join(", ")
                          }
                        >
                          {whatsapps
                            .filter((w) => !w.channel || w.channel === "whatsapp")
                            .map((whatsapp) => (
                              <MenuItem key={whatsapp.id} value={whatsapp.id}>
                                <Checkbox
                                  size="small"
                                  checked={
                                    whatsappSeleted.indexOf(whatsapp.id) > -1
                                  }
                                />
                                <ListItemText primary={whatsapp.name} />
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>

                  <Grid size={12}>
                    <div className={classes.seccion}>Programación</div>
                  </Grid>

                  <Grid
                    size={{
                      xs: 12,
                      sm: 6,
                      md: canalCampana === "whatsapp_cloud" ? 6 : 4
                    }}
                  >
                    <Field
                      as={TextField}
                      label={i18n.t("campaigns.dialog.form.scheduledAt")}
                      name="scheduledAt"
                      error={touched.scheduledAt && Boolean(errors.scheduledAt)}
                      helperText={
                        (touched.scheduledAt && errors.scheduledAt) ||
                        textoAgenda(values.scheduledAt)
                      }
                      variant="outlined"
                      size="small"
                      type="datetime-local"
                      slotProps={{ inputLabel: { shrink: true } }}
                      fullWidth
                      disabled={!campaignEditable}
                    />
                  </Grid>

                  <Grid
                    size={{
                      xs: 12,
                      sm: 6,
                      md: canalCampana === "whatsapp_cloud" ? 6 : 4
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      size="small"
                      fullWidth
                      disabled={!campaignEditable}
                    >
                      <InputLabel id="zona-label">{i18n.t("campaigns.dialog.form.timezone")}</InputLabel>
                      <Select
                        labelId="zona-label"
                        label={i18n.t("campaigns.dialog.form.timezone")}
                        value={zonaCampana}
                        onChange={(e) => setZonaCampana(e.target.value)}
                        MenuProps={{ PaperProps: { sx: { maxHeight: 320 } } }}
                      >
                        {zonas.map((z) => (
                          <MenuItem key={z.zona} value={z.zona}>
                            {etiquetaZona(z.zona)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {canalCampana !== "whatsapp_cloud" && (
                    <Grid size={{ xs: 12, md: 4 }}>
                      <FormControl variant="outlined" size="small" fullWidth>
                        <InputLabel id="confirmation-selection-label">
                          {i18n.t("campaigns.dialog.form.confirmation")}
                        </InputLabel>
                        <Field
                          as={Select}
                          label={i18n.t("campaigns.dialog.form.confirmation")}
                          labelId="confirmation-selection-label"
                          id="confirmation"
                          name="confirmation"
                          error={
                            touched.confirmation && Boolean(errors.confirmation)
                          }
                          disabled={!campaignEditable}
                        >
                          <MenuItem value={false}>Desactivada</MenuItem>
                          <MenuItem value={true}>Activada</MenuItem>
                        </Field>
                      </FormControl>
                    </Grid>
                  )}

                  {canalCampana !== "whatsapp_cloud" && (
                  <Grid size={12}>
                    <Tabs
                      value={messageTab}
                      indicatorColor="primary"
                      textColor="primary"
                      onChange={(e, v) => setMessageTab(v)}
                      variant="fullWidth"
                      centered
                      className={classes.tabs}
                    >
                      <Tab label="Msg. 1" index={0} />
                      <Tab label="Msg. 2" index={1} />
                      <Tab label="Msg. 3" index={2} />
                      <Tab label="Msg. 4" index={3} />
                      <Tab label="Msg. 5" index={4} />
                    </Tabs>
                    <Box style={{ paddingTop: 20, border: "none" }}>
                      {messageTab === 0 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid
                                size={{
                                  xs: 12,
                                  md: 8
                                }}>
                                <>
                                  {renderMessageField("message1", errors, touched)}
                                  {renderAddTextButton("message1")}
                                </>
                              </Grid>
                              <Grid
                                size={{
                                  xs: 12,
                                  md: 4
                                }}>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage1"
                                  )}
                                </>
                              </Grid>
                            </Grid>
                          ) : (
                            <>
                              {renderMessageField("message1", errors, touched)}
                              {renderAddTextButton("message1")}
                            </>
                          )}
                        </>
                      )}
                      {messageTab === 1 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid
                                size={{
                                  xs: 12,
                                  md: 8
                                }}>
                                <>
                                  {renderMessageField("message2", errors, touched)}

                                </>
                              </Grid>
                              <Grid
                                size={{
                                  xs: 12,
                                  md: 4
                                }}>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage2"
                                  )}
                                </>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message2", errors, touched)}
                              {renderAddTextButton("message2")}</>
                          )}
                        </>
                      )}
                      {messageTab === 2 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid
                                size={{
                                  xs: 12,
                                  md: 8
                                }}>
                                <>
                                  {renderMessageField("message3")}

                                </>
                              </Grid>
                              <Grid
                                size={{
                                  xs: 12,
                                  md: 4
                                }}>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage3"
                                  )}
                                </>
                              </Grid>
                            </Grid>
                          ) : (
                            <>
                              {renderMessageField("message3", errors, touched)}
                              {renderAddTextButton("message3")}</>
                          )}
                        </>
                      )}
                      {messageTab === 3 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid
                                size={{
                                  xs: 12,
                                  md: 8
                                }}>
                                <>
                                  {renderMessageField("message4", errors, touched)}

                                </>
                              </Grid>
                              <Grid
                                size={{
                                  xs: 12,
                                  md: 4
                                }}>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage4"
                                  )}
                                </>
                              </Grid>
                            </Grid>
                          ) : (
                            <>
                              {renderMessageField("message4", errors, touched)}
                              {renderAddTextButton("message4")}</>
                          )}
                        </>
                      )}
                      {messageTab === 4 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid
                                size={{
                                  xs: 12,
                                  md: 8
                                }}>
                                <>
                                  {renderMessageField("message5", errors, touched)}

                                </>
                              </Grid>
                              <Grid
                                size={{
                                  xs: 12,
                                  md: 4
                                }}>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage5"
                                  )}
                                </>
                              </Grid>
                            </Grid>
                          ) : (
                            <>
                              {renderMessageField("message5", errors, touched)}
                              {renderAddTextButton("message5")}</>
                          )}
                        </>
                      )}
                    </Box>
                  </Grid>
                  )}
                  {canalCampana !== "whatsapp_cloud" && (campaign.mediaPath || attachment) && (
                    <Grid size={12}>
                      <Button startIcon={<AttachFileIcon />}>
                        {attachment != null
                          ? attachment.name
                          : campaign.mediaName}
                      </Button>
                      {campaignEditable && (
                        <IconButton onClick={() => setConfirmationOpen(true)} color="secondary" size="large">
                          <DeleteOutlineIcon />
                        </IconButton>
                      )}
                    </Grid>
                  )}
                </Grid>
                  </Grid>

                  {hayPreview && (
                    <Grid size={{ xs: 12, md: 5 }}>
                      <div className={classes.columnaPreview}>
                        <div className={classes.seccion}>
                          Así lo recibirá el contacto
                        </div>
                        {plantillaActual ? (
                          <TemplatePreview
                            template={plantillaActual}
                            variables={plantillaActual.variables || []}
                            buttons={plantillaActual.buttons || []}
                            valores={valoresParaPreview(plantillaActual)}
                            titulo={plantillaActual.name}
                          />
                        ) : (
                          <div className={classes.previewVacia}>
                            <ChatBubbleIcon className={classes.previewIcono} />
                            <span>
                              Elige una plantilla para ver cómo llegará el
                              mensaje
                            </span>
                          </div>
                        )}
                      </div>
                    </Grid>
                  )}
                </Grid>
              </DialogContent>
              <DialogActions>
                {campaign.status === "CANCELADA" && (
                  <Button
                    color="primary"
                    onClick={() => restartCampaign()}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.restart")}
                  </Button>
                )}
                {campaign.status === "EM_ANDAMENTO" && (
                  <Button
                    color="primary"
                    onClick={() => cancelCampaign()}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.cancel")}
                  </Button>
                )}
                {canalCampana !== "whatsapp_cloud" &&
                  !attachment &&
                  !campaign.mediaPath &&
                  campaignEditable && (
                  <Button
                    color="primary"
                    onClick={() => attachmentFile.current.click()}
                    disabled={isSubmitting}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.attach")}
                  </Button>
                )}
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting}
                  variant="outlined"
                >
                  {i18n.t("campaigns.dialog.buttons.close")}
                </Button>
                {(campaignEditable || campaign.status === "CANCELADA") && (
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting}
                    variant="contained"
                    className={classes.btnWrapper}
                  >
                    {campaignId
                      ? `${i18n.t("campaigns.dialog.buttons.edit")}`
                      : `${i18n.t("campaigns.dialog.buttons.add")}`}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                )}
              </DialogActions>
            </Form>
            );
          }}
        </Formik>
        )}
      </Dialog>
    </div>
  );
};

export default CampaignModal;
